import React from 'react';
import { Modal, Form, Input, Checkbox } from 'antd';
import BaseComponent from 'components/BaseComponent';
import { connect } from 'dva';
//消息提示
import config from '@/config';

const notice = config.notice;
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;

@connect(({ homePage, loading }) => ({
    homePage,
    submitting: loading.effects['homePage/updatePassword']
}))
@Form.create()
/** 状态设置模态框 */
export default class StatusSettingModal extends BaseComponent {
    constructor() {
        super();
        this.state = {
            abnormalRemindStatus: "",
            expireRemindStatus: "",
        };
    }

    onChange = (checkedValues) => {
        // console.log('checked = ', checkedValues[0]);
        // console.log('checked = ', checkedValues[1]);
    }


    render() {
        const { statusSettingModalVisible, hideStatusSettingModal, user } = this.props;

        // let rows = [];
        // if(user.abnormalRemindStatus === '1'){
        //     rows.push('0');
        // }
        // if(user.expireRemindStatus === '1'){
        //     rows.push('1');
        // }

        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };

        // const tailFormItemLayout = {
        //     wrapperCol: {
        //         xs: {
        //             span: 13,
        //             offset: 13
        //         },
        //         sm: {
        //             span: 13,
        //             offset: 13
        //         }
        //     }
        // };

        const statusOptions = [
            { label: window.language['homepage.statusSettings.statusOptions1'], value: '0' },
            { label: window.language['homepage.statusSettings.statusOptions2'], value: '1' },
        ];

        this.handleSubmit = (e) => {
            e.preventDefault();
            const { form, dispatch } = this.props;
            form.validateFields({ force: true }, (err, values) => {
                if (!err) {
                    dispatch({
                        type: 'homePage/updateUserRemindStatus',
                        payload: {
                            ...values
                        },
                        success: () => {
                            this.props.hideStatusSettingModal();
                            notice.success(window.language['homepage.statusSettings.setMessage']);
                        }
                    });
                }
            });
        };

        return (
            statusSettingModalVisible &&
            <Modal
                title={window.language['homepage.statusSettings.abnormal']}
                visible={statusSettingModalVisible}
                onOk={this.handleSubmit}
                onCancel={hideStatusSettingModal}
                height={306}
            >
                <Form onSubmit={this.handleSubmit}>
                    <FormItem>{getFieldDecorator('id', {
                        initialValue: user.id || '',
                    }
                    )(<Input type="hidden" />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label={window.language['homepage.statusSettings.email']}>
                        {getFieldDecorator('remindEmail', {
                            rules: [
                                {
                                    required: true,
                                    message: window.language['homepage.statusSettings.enterEmail']
                                }
                            ],
                            initialValue: user.remindEmail ? user.remindEmail : "",
                        })(<Input type="eamil" />)}
                    </FormItem>
                    <FormItem {...formItemLayout} label={window.language['homepage.statusSettings.selectAbnormalType']}>
                        {getFieldDecorator('statusCombination', {
                            rules: [
                                {
                                    required: true,
                                    message: window.language['homepage.statusSettings.chooseAbnormalType']
                                }
                            ],
                            initialValue: user.abnormalRemindStatus === '1' && user.expireRemindStatus === '1' ? ['0', '1'] : (user.abnormalRemindStatus === '1' ? ['0'] : (user.expireRemindStatus === '1' ? ['1'] : "")),
                        })(<CheckboxGroup options={statusOptions} onChange={this.onChange} />)}
                    </FormItem>
                </Form>
            </Modal>
        );
    }

}


// WEBPACK FOOTER //
// ./src/routes/HomePage/components/statusSetting.js